import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './pages/Home'; 
import './App.css';
import Login from './pages/Auth/Login';
import ContestantDashboard from './pages/User/ContestantDashboard';
import UploadTrack from './pages/User/UploadTrack';
import JudgeDashboard from './pages/Judge/JudgeDashboard';
import ExamineTrack from './pages/Judge/ExamineTrack';

function App() {
  return (
    <Router>
      <div className="App">
      

        {/* Route Definitions */}
        <header className="App-header">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/contestant/dashboard" element={<ContestantDashboard />} />


<Route path="/contestant/upload"       element={<UploadTrack />} />
        <Route path="/judge/dashboard"         element={<JudgeDashboard />} />
        <Route path="/judge/examine"           element={<ExamineTrack />} />

  
          </Routes>
        </header>
      </div>
    </Router>
  );
}

export default App;